import React from "react";

import styled from "@mui/material/styles/styled";

import Button, { ButtonProps } from "@rui/Button";
import Link from "@rui/Link";

export const CreditsLinkButton = styled((props: ButtonProps<typeof Link>) => (
  <Button disableRipple component={Link} {...props} />
))(({ theme }) => ({
  borderRadius: "4px",
  color: theme.palette.info.main,
  padding: "8px 12px",
  height: "auto",
  boxShadow: "none",

  "&:hover": {
    backgroundColor: theme.palette.transparent.black[7],
  },
}));
